import { memo } from "react";
import { Col, Empty, Row, Skeleton } from "antd";

// Responsive grid that renders skeletons while loading, an Empty state when
// there are no items, and `renderItem` for each item otherwise.
const SectionGrid = ({ items, isLoading, emptyText, colProps, renderItem }) => {
    if (isLoading) {
        return (
            <Row gutter={[16, 16]} align="stretch">
                {Array.from({ length: 4 }).map((_, i) => (
                    <Col key={i} {...colProps}>
                        <div className="jw-card" style={{ padding: 16 }}>
                            <Skeleton active paragraph={{ rows: 4 }} />
                        </div>
                    </Col>
                ))}
            </Row>
        );
    }
    if (!items.length) return <Empty description={emptyText} style={{ padding: 24 }} />;
    return (
        <Row gutter={[16, 16]} align="stretch">
            {items.map((item) => (
                <Col key={item.id} {...colProps}>{renderItem(item)}</Col>
            ))}
        </Row>
    );
};

export default memo(SectionGrid);
